    import React, { useEffect, useState } from "react";
    import { useNavigate, useParams } from "react-router-dom";
    import { Card, Typography, Spin, Button } from "antd";
    import DOMPurify from "dompurify";
    import axios from "axios";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import { ArrowLeftOutlined } from "@ant-design/icons";
import lang from "../helper/lang";

    const { Title, Paragraph } = Typography;

    const ViewContent = () => {
    const { id } = useParams();
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { request } = useRequest();

  const handleBack = () => {
    navigate(-1);
  };
    useEffect(() => {
        const fetchContent = async () => {
         setLoading(true);

  request({
    url: `/admin/content/${id}`,
    method: "GET",
    onSuccess: (data) => {
      setContent(data.data);
      setLoading(false);
    },
    onError: (error) => {
      console.error("Failed to fetch content:", error);
      ShowToast(error, Severty.ERROR); // Optional if you're using toast feedback
      setLoading(false);
    },
  });
        };

        fetchContent();
    }, [id]);

    if (loading) return <Spin />;

    if (!content) return <p>Content not found.</p>;

    return (
      <>
       <div className="back-box-btn">
        <Button onClick={handleBack} className="back-button mb-2">
          <ArrowLeftOutlined /> {lang("Back")}
        </Button>
      </div>
        <Card title="View Content">
        <Title level={4}>{content.name}</Title>

            
                <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(content.description || ""),
                }}
                />
           
            
        </Card>
      </>
    );
    };

    export default ViewContent;
